import {useUserStore} from "@/stores/useUser.js";
import {useHHttp} from "@/hooks/useHHttp.js";
import {hsp, SaveEnum} from "@/components/utils/HSp.js";
import {emitter, hcf} from "@/components/utils/HComFunctions.js";
import {showDialog, showToast} from "vant";
import {hdi} from "@/components/utils/HDeviceInfo.js";
import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
import {hr} from "@/components/utils/HRouter.js";

const h5DownloadApkUrl = ref("");
const h5DownloadIosUrl = ref("");
const h5DownloadIosJumpUrl = ref("");
//推广弹窗数据
const downloadDomainList = ref([]);
const homeBannerList = ref([]);
const homeNoticeList = ref([]);
const homeAdList = ref([]);
const hasClaimableActivity = ref(false);


export function useHComApi() {

    const useUser = useUserStore();
    const useHttp = useHHttp();

    function openService() {
        useHttp.request("/qp/app/kf/v2", (data) => {
            hr.go("wb", {
                "title": "客服",
                "url": data["CsUrl"] ?? "",
            });
        }).then(r => {
        });
    }

    function updateAppConfig(successCallback) {
        useHttp.request("/qp/app/config", (data) => {
            h5DownloadIosUrl.value = data["IosUrl"] ?? "";
            h5DownloadApkUrl.value = data["ApkUrl"] ?? "";
            h5DownloadIosJumpUrl.value = data["IosJumpUrl"] ?? "";
            //
            if ("GameNotice" in data) {
                let tempList = [];
                for (let i = 0; i < data["GameNotice"].length; i++) {
                    tempList.push(data["GameNotice"][i]["Content"]);
                }
                homeNoticeList.value = tempList;
            }
            homeBannerList.value = data["BannerConfig"] ?? [];
            homeAdList.value = data["AdConfig"] ?? [];
            if (successCallback) {
                successCallback();
            }
            downloadDomainList.value = data["OfficialWebsite"] ?? [];
        }, {
            isShowLoading: false, params: {"Did": hdi.deviceId, "Code": hdi.inviteCode}
        }).then(r => {
        });
    }

    // 活动功能暂未上线: 关掉活动红点协议, 不再发 /qp/app/red-dot
    // 恢复时把 ACTIVITY_RED_DOT_ENABLED 改回 true 即可
    const ACTIVITY_RED_DOT_ENABLED = false;
    let lastRedDotFetchAt = 0;
    function fetchRedDot() {
        if (!ACTIVITY_RED_DOT_ENABLED) {
            hasClaimableActivity.value = false;
            return Promise.resolve();
        }
        const now = Date.now();
        if (now - lastRedDotFetchAt < 300) return Promise.resolve();
        lastRedDotFetchAt = now;
        return useHttp.request("/qp/app/red-dot", (data) => {
            if (!data?.modules?.activity) return;
            hasClaimableActivity.value = !!data.modules.activity.has_red;
        }, {isShowLoading: false});
    }

    function clearRedDot() {
        hasClaimableActivity.value = false;
    }

    function refreshUserBalance({isShowToast = false} = {}) {
        if (useUser.isLogin) {
            useHttp.request("/game/wallet/account/lookup",
                (data) => {
                    useUser.totalMoney = hcf.getMoneyValue(data["Total"].toString());
                    useUser.availableMoney = hcf.getMoneyValue(data["Avaliable"].toString());
                    if (isShowToast) {
                        showToast('余额已更新');
                    }
                }, {
                    isShowLoading: isShowToast,
                }).then(r => {
            });
        }
    }

    function updateUserInfo() {
        useHttp.request("/app/profile/obtain", (resp) => {
            let data = resp["Data"] ?? {};
            if (data) {
                useUser.updateUserRefs({
                    userId: data["UserId"],
                    inviteCode: data["InviteCode"],
                    avatar: data["Avatar"] ?? "",
                    phoneNumber: data["Mobile"],
                    areaCode:
                        data["AreaCode"] === "" ? "+86" : data["AreaCode"],
                    userName: data["UserName"],
                    showUserId: data["ShowAppUserId"],
                    birthday: data["Birth"],
                    gender: data["Gender"],
                    realName: data["RealName"],
                    isHaveSafePwd: data["HaveSafePasswd"] === 1,
                    isHavePwd: data["HavePasswd"] === 1,
                    withdrawMap:
                        hcf.processWithDrawData(data["WithDrawMap"]),
                    vipLevel: data["VipLevel"] ?? 0,
                    currentExp: data["CurrentExp"] ?? 0,
                    nextExp: data["NextExp"] ?? 0,
                    addressList: data["DeliveryList"] ?? [],
                    appId: data["AppId"] ?? "",
                    alipayAccount: data["AlipayAccount"] ?? "",
                });
                emitter.emit("REFRESH_HOME_LOBBY_LIST");
            } else {
                showToast("账号信息不存在 NULL");
            }
        }, {
            params: {
                "UserId": useUser.userId
            }
        }).then(r => {
        });
    }

    function loginSuccess(loginData) {
        let data = loginData["Data"] ?? loginData;
        if ("GameToken" in data) {
            useUser.token = data["GameToken"];
            useHttp.setToken();
        }
        if ("UserId" in data) {
            useUser.userId = data["UserId"];
        }
        useUser.isLogin = true;
        hsp.setString(SaveEnum.userId, useUser.userId);
        hsp.setString(SaveEnum.userToken, useUser.token);
        refreshUserBalance();
        updateUserInfo();
        fetchRedDot();
    }

    function errorLoginAlert(lsUserId,lsToken){
        let py = localStorage.getItem("py");
        showDialog({
            title: '登录游戏失败',
            message: `请您尝试重新打开APP进行重试\n(如果多次无法正常进入,请截图联系客服)\n\nERROR(${hdi.appVersion}):\n${lsUserId}\n${lsToken}\n\n${py}`,
            confirmButtonText: "请关闭APP,重新打开",
            confirmButtonColor: hcf.getMainColor(),
        }).then(r => {
            errorLoginAlert();
        });
    }

    function refreshToken() {
        let lsUserId = hsp.getString(SaveEnum.userId);
        let lsToken = hsp.getString(SaveEnum.userToken);
        if ((useUser.userId && useUser.token)||(lsUserId && lsToken)) {
            if(lsUserId && lsToken){
                useUser.token = lsToken;
                useUser.userId = lsUserId;
            }
            useHttp.setToken();
            useHttp.request("/app/login/refresh", (data) => {
                loginSuccess(data);
            }, {
                params: {
                    "UserId": useUser.userId,
                    "Did": hdi.deviceId
                }, isShowLoading: false
            }).then(r => {
            });
        } else {
            //自动注册账号用到的
            if (hdi.channelFlag !== 'main' && hdi.channelFlag !== 'devv') {
                //正常逻辑不应该走到这里,弹出一个窗口提醒
                errorLoginAlert(lsUserId,lsToken);
            //     useHttp.request("/app/third/account/look", (data) => {
            //         loginSuccess(data);
            //     }, {
            //         params: {
            //             "AppUserId": HNewGameUIConfig.getProjectUserId(),
            //             "AppId": hdi.channelFlag
            //         }
            //     }).then(r => {
            //     });
            }
        }
    }

    function modifyUserBase(useEleMap, callback, showToast = "") {
        let reqJson = {
            "AppId": useUser.appId,
            "UserId": useUser.userId,
        };
        for (let key in useEleMap) {
            reqJson[key] = useEleMap[key];
        }
        useHttp.request("/app/profile/modify-base", () => {
            if (showToast && showToast !== "") {
                showToast(showToast);
            }
            if (callback) {
                callback();
            }
        }, {
            params: reqJson
        }).then(r => {
        });
    }

    function getSecondGameData(
        callBack, {
            innerNavId = 0,
            childNavId = 0,
            tabType = 0,
            tag1Id = 0,
            tag2Id = 0,
            start = 0,
            limit = 24,
            isShowLoading = true,
        } = {}) {
        useHttp.request("/qp/game/inner-lobby", callBack,
            {
                params: {
                    "AppId": useUser.appId,
                    "AppUserId": useUser.userId,
                    "InnerNavId": innerNavId,
                    "ChildNavId": childNavId,
                    "TabType": tabType,
                    "Tag1Id": tag1Id,
                    "Tag2Id": tag2Id,
                    "Start": start,
                    "Limit": limit,
                },
                isShowLoading: isShowLoading
            }).then(r => {});
    }

    function removeHttp(input) {
        if (!input) return "";
        return input.replace(/^https?:\/\//i, "");
    }

    return {
        getSecondGameData,
        modifyUserBase,
        openService,
        loginSuccess,
        updateUserInfo,
        refreshUserBalance,
        refreshToken,
        updateAppConfig,
        homeBannerList,
        homeNoticeList,
        homeAdList,
        h5DownloadApkUrl,
        h5DownloadIosUrl,
        h5DownloadIosJumpUrl,
        downloadDomainList,
        removeHttp,
        hasClaimableActivity,
        fetchRedDot,
        clearRedDot,
    };
}
